export default "__VITE_ASSET__CKe4xyFQ__"